import { request } from "@/api/server/index";

export default {
  //V027_最近表示した団体一覧画面
  RecentlyOrg: {
    indexRecentlyOrg(params) {
      return request({
        url: "/recentlyOrg/indexRecentlyOrg",
        data: params,
        method: "post"
      });
    }
  },
  // V028_団体検索・新規登録画面
  OrgSearch: {
    indexOrgSearch(params) {
      return request({
        url: "/orgSearch/indexOrgSearch",
        data: params,
        method: "post"
      });
    },
    //V028_検索
    searchOrgSearchList(params) {
      return request({
        url: "/orgSearch/searchOrgSearchList",
        data: params,
        method: "post"
      });
    }
  },
  // V029_団体情報画面
  OrgAllInfo: {
    // 初期表示
    indexOrgAllInfo(params) {
      return request({
        url: "/orgAllInfo/indexOrgAllInfo",
        data: params,
        method: "post"
      });
    },
    //一括削除
    deleteOrgAllInfo(params) {
      return request({
        url: "/orgAllInfo/deleteOrgAllInfo",
        data: params,
        method: "post"
      });
    },
    //ファイル名（b17）をクリックしたときの処理
    downloadDocumentMetadataFile(params) {
      return request({
        url: "/orgAllInfo/downloadDocumentMetadataFile",
        data: params,
        responseType: "blob",
        method: "post"
      });
    }
  },
  // V030_団体検索・新規登録画面
  OrgEdit: {
    // 初期表示
    indexOrgEdit(params) {
      return request({
        url: "/orgEdit/indexOrgEdit",
        data: params,
        method: "post"
      });
    },
    // 登録(新規登録)
    insertOrgEdit(params) {
      return request({
        url: "/orgEdit/insertOrgEdit",
        data: params,
        method: "post"
      });
    },
    // 削除
    deleteOrgEdit(params) {
      return request({
        url: "/orgEdit/deleteOrgEdit",
        data: params,
        method: "post"
      });
    },
    // 登録(編集)
    updateOrgEdit(params) {
      return request({
        url: "/orgEdit/updateOrgEdit",
        data: params,
        method: "post"
      });
    }
  },
  // V031_団体第2階層・第3階層情報画面
  OrgSecondThirdLevelInfo: {
    // 初期表示
    indexOrgSecondThirdLevelInfo(params) {
      return request({
        url: "/orgSecondThirdLevelInfo/indexOrgSecondThirdLevelInfo",
        data: params,
        method: "post"
      });
    }
  },
  // V032_団体第2階層・第3階層登録画面
  OrgSecondThirdLevelEdit: {
    //団体第2階層登録 初期表示
    indexOrgSecondLevelEdit(params) {
      return request({
        url: "/orgSecondThirdLevelEdit/indexOrgSecondLevelEdit",
        data: params,
        method: "post"
      });
    },
    //団体第2階層 削除
    deleteOrgSecondLevelEdit(params) {
      return request({
        url: "/orgSecondThirdLevelEdit/deleteOrgSecondLevelEdit",
        data: params,
        method: "post"
      });
    },
    //団体第2階層 新規登録
    insertOrgSecondLevelEdit(params) {
      return request({
        url: "/orgSecondThirdLevelEdit/insertOrgSecondLevelEdit",
        data: params,
        method: "post"
      });
    },
    //第2階層団体登録 登録(編集)
    updateOrgSecondLevelEdit(params) {
      return request({
        url: "/orgSecondThirdLevelEdit/updateOrgSecondLevelEdit",
        data: params,
        method: "post"
      });
    },
    //団体第3階層登録 初期表示
    indexOrgThirdLevelEdit(params) {
      return request({
        url: "/orgSecondThirdLevelEdit/indexOrgThirdLevelEdit",
        data: params,
        method: "post"
      });
    },
    //団体第3階層 削除
    deleteOrgThirdLevelEdit(params) {
      return request({
        url: "/orgSecondThirdLevelEdit/deleteOrgThirdLevelEdit",
        data: params,
        method: "post"
      });
    },
    //団体第3階層 新規登録
    insertOrgThirdLevelEdit(params) {
      return request({
        url: "/orgSecondThirdLevelEdit/insertOrgThirdLevelEdit",
        data: params,
        method: "post"
      });
    },
    //団体第3階層登録 第3階層団体登録 登録(編集)
    updateOrgThirdLevelEdit(params) {
      return request({
        url: "/orgSecondThirdLevelEdit/updateOrgThirdLevelEdit",
        data: params,
        method: "post"
      });
    }
  }
};
